var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{staticClass:"ed-link",attrs:{"disabled":_vm.disabled,"href":_vm.href,"icon":_vm.icon,"type":_vm.type,"underline":_vm.underline,"target":_vm.target},on:{"click":_vm.navTo}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }